import { render, staticRenderFns } from "./SetupSidebarNoBrands.vue?vue&type=template&id=337f15ce"
import script from "./SetupSidebarNoBrands.vue?vue&type=script&lang=js"
export * from "./SetupSidebarNoBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports